import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useContext } from "react";
import { UserContext } from "../UserContext/UserContext";

const ProtectedRoutes = () => {
  const { user } = useContext(UserContext);
  const location = useLocation();

  // Check if user is authenticated via UserContext
  // Cookies are sent automatically, so we just need to verify user data exists
  const isAuthenticated = !!user;

  if (!isAuthenticated) {
    // Redirect to the login page and pass the current location in state
    // so it can be used after successful login
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // If the user is authenticated, render the Outlet to display nested routes
  return (
    <div className="grid grid-cols-1 gap-4 xl:w-4/5 xl:mx-auto">
      <Outlet />
    </div>
  );
};

export default ProtectedRoutes;
